import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import logoJatear from '../../assets/logo_jatear.png';
import styles from './Login.module.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');

  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const loading = useAuthStore((state) => state.loading);

  async function handleEntrar(e) {
    e.preventDefault();
    setErro('');

    if (!email || !senha) {
      setErro('Informe e-mail e senha.');
      return;
    }

    try {
      await login(email, senha);
      // Le do store apos o login pra saber se precisa trocar senha
      const precisa = useAuthStore.getState().precisaTrocarSenha;
      navigate(precisa ? '/trocar-senha' : '/dashboard');
    } catch (err) {
      const msgPorCodigo = {
        'auth/invalid-credential': 'E-mail ou senha inválidos.',
        'auth/invalid-email': 'E-mail inválido.',
        'auth/user-not-found': 'Usuário não encontrado.',
        'auth/wrong-password': 'Senha incorreta.',
        'auth/too-many-requests': 'Muitas tentativas. Tente novamente em alguns minutos.',
        'auth/network-request-failed': 'Falha de conexão. Verifique sua internet.',
      };
      setErro(msgPorCodigo[err.code] || 'Não foi possível entrar. Tente novamente.');
    }
  }

  return (
    <div className={styles.wrap}>
      <form className={styles.card} onSubmit={handleEntrar}>
        <div className={styles.header}>
          <img
            className={styles.logoJatear}
            src={logoJatear}
            alt="Jatear Tratamento Anticorrosivo Ltda"
          />
        </div>

        <div className={styles.faixa}>Gestão de Tintas</div>

        <div className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              disabled={loading}
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="senha">Senha</label>
            <input
              id="senha"
              type="password"
              placeholder="••••••••"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          {erro && <div className={styles.erro}>{erro}</div>}

          <button
            type="submit"
            className={styles.btnEntrar}
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </div>

        <div className={styles.footer}>
          Jatear Tratamento Anticorrosivo Ltda &nbsp;·&nbsp; v1.0
        </div>
      </form>
    </div>
  );
}
